var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "main-content flex-1 bg-gray-100 mt-20 md:mt-20 pb-50 md:pb-5 overflow-y-scroll"
    },
    [
      _c("div", { staticClass: "flex flex-wrap" }, [
        _c("div", { staticClass: "w-full p-3" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "overflow-y-auto" },
            [
              _c(
                "div",
                { staticStyle: { "margin-bottom": "10px" } },
                [
                  _c(
                    "el-row",
                    { staticClass: "px-5 py-2 " },
                    [
                      _c("el-col", {
                        staticClass: "flex flex-row justify-end",
                        attrs: { span: 24 }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "data-tables-server",
                {
                  ref: "tableTransaction",
                  attrs: {
                    data: _vm.data,
                    total: _vm.total,
                    "pagination-props": {
                      background: true,
                      pageSizes: [_vm.displayingItem]
                    }
                  },
                  on: { "query-change": _vm.onChangeTable }
                },
                [
                  _vm._l(_vm.titles, function(title) {
                    return _c("el-table-column", {
                      key: title.prop,
                      attrs: {
                        prop: title.prop,
                        label: title.label,
                        sortable: "custom"
                      }
                    })
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "Actions",
                      align: "right",
                      "min-width": "100px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", {
                              staticClass:
                                "static inline-block text-left container-action"
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                2
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "bg-gray-400 border-b-2 border-gray-500 rounded-tl-lg rounded-tr-lg p-2"
      },
      [
        _c("h5", { staticClass: "font-bold uppercase text-gray-600" }, [
          _vm._v("Subscription Verify Student History")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12e57829", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12e57829","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SubscriptionVerifyStudentHistory.vue
// module id = null
// module chunks = 